import axios from './axiosConfig'

export const getDictListService = (): Promise<any> => {
  return axios.get('/dic/listAll')
}

export const getDictDetailService = (type: string): Promise<any> => {
  return axios.get(`/dic/listByType/${type}`)
}

export const getRolesService = (): Promise<any> => {
  return axios.post(`/role/getRoles`)
}